<template>
    <div ref="soh-chart-container" class="soh-chart-box">
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'SohChart',
    methods: {
        getOption() {
            const option = {
                grid: {
                    top: 20,
                    left: 40,
                    bottom: 30,
                    right: 10
                },
                xAxis: {
                    type: 'category',
                    data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,15, 16, 17, 18, 19, 20],
                    axisLabel: {
                        color: '#E3F0FF',
                        fontSize: 12,
                        fontWeight: 700
                    },  
                    axisLine: {
                        lineStyle: {
                            color: '#0C89AD',
                            opacity: 0.3
                        }
                    },
                },
                yAxis: {
                    type: 'value',
                    name: '电池号',
                    nameLocation: 'start',
                    min: 90,
                    nameTextStyle: {
                        color: '#E3F0FF',
                        align: 'right'
                    }, 
                    axisLabel: {
                        color: '#E3F0FF',
                        fontSize: 12,
                        fontWeight: 700
                    }, 
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#0C89AD',
                            opacity: 0.3
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#094B85'],
                            opacity: 0.3
                        }
                    }
                },
                series: [{
                    data: [100, 99, 99, 98, 99, 98,99, 100, 99, 99, 98, 99,99, 100, 99, 99, 100, 98, 99, 99 ],
                    type: 'bar',
                    itemStyle: {
                        color: 'rgba(45, 146, 255, .4)'
                    },
                    barWidth: 8
                }
               ]
            };
            return option;
        }
    },
    mounted() {
        const chartDom = this.$refs['soh-chart-container'];
        const myChart = echarts.init(chartDom);
        myChart.setOption(this.getOption());
    }
}
</script>

<style lang="less" scoped>
    .soh-chart-box {
        height: 100%;
        width: 100%;
    }
</style>